// import { useEffect, useState } from "react";
// import AdminCards from "../../components/AdminCards";
// import Onboarding from "../../components/Emergency/AdminOnboarding";
// import LatestResidentsAndChart from "../../components/AdminChart";
// import WithAuth from "../../components/partials/withAuth";
// import { useParams } from "react-router-dom";
// import { MssgContainer, getEstateID } from "../../components/partials/utils";
// import {
//   getCookie,
//   HOST_URL,
//   reqOptions,
//   SK_VALUE,
// } from "../../assets/js/helpFunction";
// import Adverts from "../../components/CreateAds";

// const Overview = () => {
//   const [analyticsData, setAnalyticsData] = useState([]);
//   console.log("analyticsData", analyticsData);

//   const [mssg, setMssg] = useState({ error: false, mssg: "" });
//   const [data, setData] = useState({
//     estate: {},
//     zones: [],
//     streets: [],
//   });

//   const closeMssg = () => {
//     setMssg({ error: false, mssg: "" });
//   };

//   useEffect(() => {
//     let myHeaders = new Headers();
//     myHeaders.append("EstateIQ-Sk-Header", SK_VALUE());
//     myHeaders.append("Authorization", "Bearer " + getCookie("access"));

//     let requestOptions = {
//       method: "GET",
//       headers: myHeaders,
//       redirect: "follow",
//     };
//     fetch(
//       HOST_URL() +
//         `estate_access_logs/code-tracking/?estate_id=${getEstateID()}`,
//       requestOptions
//     )
//       .then((response) => response.json())
//       .then((data) => setAnalyticsData(data))
//       .catch((error) => console.log("error", error));
//   }, []);

//   useEffect(() => {
//     const requestOptions = reqOptions("get", null, true);
//     const estate_api = `${HOST_URL()}estates/estate_detail/${getEstateID()}`;
//     const streets_api = `${HOST_URL()}estates/estates_street_no_zone/?estate_id=${getEstateID()}`;
//     const analytics_api = `${HOST_URL()}estate_users/estate_user_analytics/?estate_id=${getEstateID()}`;
//     const residents_api = `${HOST_URL()}estate_users/admin_list?estate_id=${getEstateID()}&limit=10`;
//     Promise.all([
//       fetch(estate_api, requestOptions),
//       fetch(streets_api, requestOptions),
//       fetch(analytics_api, requestOptions),
//       fetch(residents_api, requestOptions),
//     ])
//       .then(function (responses) {
//         return Promise.all(
//           responses.map(function (response) {
//             return response.json();
//           })
//         );
//       })
//       .then(function (resp) {
//         setData({
//           ...data,
//           estate: resp[0],
//           streets: resp[1].results,
//           analytics: resp[2],
//           residents: resp[3].results,
//         });
//       })
//       .catch(function (error) {});
//   }, []);

//   const all_residents = data?.estate?.users_data?.all_residents;
//   const all_securities = data?.estate?.users_data?.all_securities;
//   const all_admins = data?.estate?.users_data?.all_admins;

//   const handleSetResidents = (resident) => {
//     setData({
//       ...data,
//       residents: data.residents.map((item) => {
//         if (item.id === resident.id) {
//           return { ...item, status: resident.status };
//         }
//         return item;
//       }),
//     });
//   };
//   return (
//     <WithAuth>
//       {mssg.mssg && <MssgContainer mssg={mssg} close={closeMssg} />}
//       <Onboarding />
//       <AdminCards
//         residentsNo={all_residents}
//         securityNo={all_securities}
//         adminNo={all_admins}
//         data={data}
//         is_admin={true}
//       />
//       <LatestResidentsAndChart
//         // analytics={data && data.analytics}
//         residents={data && data.residents && data.residents.slice(0, 3)}
//         setResidents={handleSetResidents}
//       />

//       <table>
//         <thead>
//           <tr>
//             <th>Codes generated</th>
//             <th>Codes revoked</th>
//             <th>Codes expired</th>
//             <th>Codes validated</th>
//             <th>Week start</th>
//             <th>Week end</th>
//           </tr>
//         </thead>

//         <tbody>
//           {analyticsData?.map((data) => (
//             <tr>
//               <td>{data?.codes_generated}</td>
//               <td>{data?.codes_revoked}</td>
//               <td>{data?.codes_expired}</td>
//               <td>{data?.codes_validated}</td>
//               <td>{new Date(data?.week_start).toLocaleDateString()}</td>
//               <td>{new Date(data?.week_end).toLocaleDateString()}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       <Adverts />
//     </WithAuth>
//   );
// };

// export default Overview;

import { useEffect, useState } from "react";
import AdminCards from "../../components/AdminCards";
import Onboarding from "../../components/Emergency/AdminOnboarding";
import LatestResidentsAndChart from "../../components/AdminChart";
import WithAuth from "../../components/partials/withAuth";
import { MssgContainer, getEstateID } from "../../components/partials/utils";
import { HOST_URL, reqOptions } from "../../assets/js/helpFunction";
import Adverts from "../../components/CreateAds";
import { Link } from "react-router-dom";
import "./admin-overview.css";

const DashboardIcon = ({ name }) => {
  const paths = {
    arrow: "M5 12h14m-5-5 5 5-5 5",
    location: "M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Zm-8 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    sparkle: "m12 3 1.4 4.1L17.5 8.5l-4.1 1.4L12 14l-1.4-4.1-4.1-1.4 4.1-1.4L12 3Z",
  };

  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d={paths[name]} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

const Overview = () => {
  const [mssg, setMssg] = useState({ error: false, mssg: "" });
  const [data, setData] = useState({
    estate: {},
    zones: [],
    streets: [],
  });

  const closeMssg = () => {
    setMssg({ error: false, mssg: "" });
  };

  useEffect(() => {
    const requestOptions = reqOptions("get", null, true);
    const estate_api = `${HOST_URL()}estates/estate_detail/${getEstateID()}`;
    const streets_api = `${HOST_URL()}estates/estates_street_no_zone/?estate_id=${getEstateID()}`;
    const analytics_api = `${HOST_URL()}estate_users/estate_user_analytics/?estate_id=${getEstateID()}`;
    const residents_api = `${HOST_URL()}estate_users/admin_list?estate_id=${getEstateID()}&limit=10`;
    Promise.all([
      fetch(estate_api, requestOptions),
      fetch(streets_api, requestOptions),
      fetch(analytics_api, requestOptions),
      fetch(residents_api, requestOptions),
    ])
      .then(function (responses) {
        return Promise.all(
          responses?.map(function (response) {
            return response.json();
          })
        );
      })
      .then(function (resp) {
        setData({
          ...data,
          estate: resp[0],
          streets: resp[1].results,
          analytics: resp[2],
          residents: resp[3].results,
        });
      })
      .catch(function (error) {});
  }, []);

  const all_residents = data?.estate?.users_data?.all_residents;
  const all_securities = data?.estate?.users_data?.all_securities;
  const all_admins = data?.estate?.users_data?.all_admins;

  const handleSetResidents = (resident) => {
    setData({
      ...data,
      residents: data?.residents?.map((item) => {
        if (item.id === resident.id) {
          return { ...item, status: resident.status };
        }
        return item;
      }),
    });
  };
  return (
    <WithAuth>
      <main className="admin-overview-refresh">
        {mssg.mssg && <MssgContainer mssg={mssg} close={closeMssg} />}

        <section className="admin-overview-hero">
          <div className="admin-overview-hero-copy">
            <div className="admin-overview-kicker"><DashboardIcon name="sparkle" /> ESTATE OVERVIEW</div>
            <h1>{data?.estate?.name || "Welcome to your estate dashboard"}</h1>
            <p className="admin-overview-subtitle">Manage your community, residents and daily estate operations from one place.</p>
            <div className="admin-overview-meta">
              {data?.estate?.estate_id && <span className="admin-overview-id">{data.estate.estate_id}</span>}
              {data?.estate?.address && <span><DashboardIcon name="location" /> {data.estate.address}</span>}
            </div>
          </div>
          <Link className="admin-overview-resident-link" to="/admin/residents/">
            Manage residents <DashboardIcon name="arrow" />
          </Link>
        </section>

        <section className="admin-overview-actions" aria-label="Estate quick actions">
          <div className="admin-overview-section-copy">
            <span>QUICK ACTIONS</span>
            <p>Communicate important information to your community.</p>
          </div>
          <Onboarding />
        </section>

        <section className="admin-overview-stats">
          <div className="admin-overview-section-heading">
            <div><span>COMMUNITY SNAPSHOT</span><h2>Your estate at a glance</h2></div>
            <p>Live membership totals for this estate</p>
          </div>
          <AdminCards
            residentsNo={all_residents}
            securityNo={all_securities}
            adminNo={all_admins}
            data={data}
            is_admin={true}
          />
        </section>

        <section className="admin-overview-residents">
          <LatestResidentsAndChart
            residents={data && data.residents && data.residents.slice(0, 3)}
            setResidents={handleSetResidents}
          />
        </section>

        <section className="admin-overview-adverts">
          <div className="admin-overview-section-heading">
            <div><span>COMMUNITY DISCOVERIES</span><h2>Recommended for your estate</h2></div>
          </div>
          <Adverts />
        </section>
      </main>
    </WithAuth>
  );
};

export default Overview;
